import AdvantageCard from './advantageCard';
import style from './style.css';

const WhyCardlessEmi = () => {
  return (
    <div className={style.whyCardlessEmiOuterContainer}>
      <div className={style.whyCardlessEmiInnerContainer}>
        <div className={style.headingCard}>
          <div className={style.heading}>Why Use Cardless EMI</div>
        </div>
        <div className={style.cardContainer}>
          <div className={style.card}>
            <AdvantageCard
              icon='https://iccdn.in/campaigns/page/clock-Icon-blue.svg'
              heading='Buy Now Pay Later'
              subHeading='0 downpayment'
            />
            <AdvantageCard
              icon='https://iccdn.in/campaigns/page/mobile-Icon-blue.svg'
              heading='Shop with Mobile number'
              subHeading='No card needed'
            />
            <AdvantageCard
              icon='https://iccdn.in/campaigns/page/bank-Icon-blue.svg'
              heading='Pre-approved by your Lender'
              subHeading='No KYC, no paperwork'
            />
          </div>
          <div className={style.card}>
            <AdvantageCard
              icon='https://iccdn.in/campaigns/page/payment-Icon-blue.svg'
              heading='Easy repayments'
              subHeading='Auto-debit from bank account'
            />

            <AdvantageCard
              icon='https://iccdn.in/campaigns/page/emi-Icon-blue.svg'
              heading='EMI Tenure'
              subHeading='Flexible EMI tenures. 3-18 months'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyCardlessEmi;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVC/whyCardlessEmi/index.js